package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_03_10_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes in the Leering Stag in Ybrallan.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Damon informs our heroes of Jemrin’s departure. Damon is concerned about the lack of healing capabilities in the heroes’ party and suggests that they meet with an adventurer in town named Falorn. Our heroes meet Falorn downstairs in the Leering Stag. He is 6 feet tall and 170 lbs and has light brown hair, carrying a Warhammer, dagger, and shield.  He does not wear loud green makeup.  Falorn expresses interest in joining our heroes on their quest, assuming it pays well. Our heroes are not overwhelmed by Falorn, but think he would be helpful and agree that all people of Veldekar have a stake in protecting the plane from demonic forces.  Falorn joins the party and learns about the triangle and the risk from Dorvidian assassins.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette suggests a new solution to containing the triangle — she has learned to turn an ordinary bag into a bag of holding. Caper asks Streelia about the best place to buy a bag in town.  There isn’t any specialty store, Streelia suggests “Jason’s Outfitters” which our heroes were planning to visit anyway.  The party is quite interested in Annette’s replication process.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In the afternoon 3:30pm, our heroes embark toward Dorb (where they intend to meet Sir Sorlon Dragstone and Sir Lorn Fogarth). There is light rain in the afternoon and into the night but is otherwise uneventful.")
    }
}
